import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { SnackbarService } from "@core/services/snackbar.service";
import { UserStateService } from "@core/services/common/user-state.service";

const DEVELOPER_USERS = ["desa"];

const normalizeUser = (value: string | null | undefined): string =>
  String(value ?? "")
    .trim()
    .toLowerCase();

export const DeveloperOnlyGuard: CanActivateFn = () => {
  const router = inject(Router);
  const snackbar = inject(SnackbarService);
  const userStateService = inject(UserStateService);

  userStateService.initializeFromSession();

  const allowedUsers = DEVELOPER_USERS.map(normalizeUser).filter(Boolean);
  const userCandidates = [
    normalizeUser(userStateService.usuario()),
    normalizeUser(sessionStorage.getItem("dusuario")),
  ].filter(Boolean);

  const hasAccess =
    !environment.production &&
    allowedUsers.length > 0 &&
    userCandidates.some((user) => allowedUsers.includes(user));

  if (hasAccess) {
    return true;
  }

  return router.createUrlTree(["/inicio"]);
};
